<template>
  <div class="register-page">
    <div :class="computedClass">
      <!-- <div class="page-title col-xs-12 col-sm-6 pt-2">
        Registrar / {{ title }} ({{ list.length }})
      </div> -->
      <div class="col-lg-6 d-flex align-items-center">
        <PageTitle :titles="['Cadastrar', title]" :dataCount="list.length" />
      </div>
      <toolbar
        class="col-xs-12 col-sm-6"
        :type="type"
        :is-mobile="ismob"
        :is-searching="isSearching"
        @search="searchBy"
        @clear-search="clearSearch"
        @edit="edit"
        @remove="removeDialog()"
        @add="add"
        :is-admin="isAdmin"
        :selected="selected"
        :number-of-elements="list.length"
        :type-filtering="''"
        :not-exists="showErrorNotFound"
        :not-search="showErrorNotSearch"
        ref="INP"
        :is-show="loading"
      />
    </div>
    <div class="container-dropdown">
      <div class="row around-xs">
        <b-dropdown
          :text="!tab1 ? 'EQUIPAMENTOS' : tab1.toUpperCase()"
          class="col-xs-6 pt-1"
          :variant="!tab1 ? 'outline-3v3' : '3v3'"
          :disabled="showErrorNotSearch || loading"
          size="sm"
        >
          <b-dropdown-item
            v-for="e in equipments"
            :key="e.type"
            @click="type = e.type"
          >
            {{ e.name }}
          </b-dropdown-item>
        </b-dropdown>
        <b-dropdown
          :text="!tab2 ? 'MODELOS' : tab2.toUpperCase()"
          class="col-xs-6 pt-1"
          :variant="!tab2 ? 'outline-3v3' : '3v3'"
          right
          size="sm"
          :disabled="showErrorNotSearch || loading"
        >
          <b-dropdown-item
            v-for="m in models"
            :key="m.type"
            @click="type = m.type"
            >{{ m.name }}</b-dropdown-item
          >
        </b-dropdown>
      </div>
    </div>
    <div class="register-main">
      <div class="list-items row">
        <div v-if="loading" class="col-xs-12 center-xs">
          <spinner /> Aguarde...
        </div>

        <div
          v-if="showErrorNotFound"
          class="EmptyRequest w-100 h-100 p-0 row center-xs center-md center-sm center-xs0 mt-3"
        >
          <img :src="emptyIcon" class="empty" />
          <span>Não há equipamentos para exibir.</span>
        </div>
        <div
          v-if="showErrorNotSearch && !showErrorNotFound"
          class="EmptyRequest row center-xs mx-2 md-12 w-100 p-0 mt-3"
          style="text-align: left"
        >
          <img :src="searchIcon" class="empty" />
          <span>
            Nenhum resultado encontrado. Para voltar a exibir todos os
            equipamentos
            <b-link @click="clearSearch"> clique aqui </b-link>.</span
          >
        </div>

        <div
          v-for="(item, index) in list"
          v-show="!loading"
          :key="index"
          class="col-xs-12 col-sm-4 col-md-3"
        >
          <div class="item-card eqp-card">
            <div class="header-card">
              <div class="card-name">
                <div class="container-card-header">
                  <div class="header-title">{{ item.NAME }}</div>
                  <div v-if="item.MAKER" class="header-maker">
                    <div class="slider">
                      <span>{{ item.MAKER }}</span>
                    </div>
                  </div>
                  <div v-if="item.NAME_MODEL" class="header-model">
                    <div class="slider">
                      <span>{{ item.NAME_MODEL }}</span>
                    </div>
                  </div>
                </div>
                <dir-icon title="Há dir" v-if="item.ID_DIR != null" />
                <calendar-clock-icon
                  title="Associado a agenda"
                  v-if="hasSchedulesAssociated(item)"
                />
              </div>
            </div>
            <div class="card-details">
              <div v-if="item.MODE != null">
                <strong>Modo:</strong> {{ modelMode[item.MODE] }}
              </div>
              <div v-if="item.ID_DIR != null">
                <strong>Dispositivo:</strong> {{ item.ID_DIR }}
              </div>
              <div v-if="item.OPEN != null">
                <strong>OPEN:</strong> {{ item.OPEN }}
              </div>
              <div v-if="item.CLOSE != null">
                <strong>CLOSE:</strong> {{ item.CLOSE }}
              </div>
              <div v-if="item.CTE">
                <strong>L/pulso:</strong> {{ item.CTE }}
              </div>
              <div v-if="item.INTERFACE_NAME">
                <strong>Interface</strong>
                <div class="slider">{{ item.INTERFACE_NAME }}</div>
              </div>
              <div v-if="item.TOTAL_POS">
                <strong>Medições:</strong> {{ item.TOTAL_POS }}
              </div>
              <div v-if="item.LATITUDE != null || item.LONGITUDE != null">
                <!-- <br /> -->
                <div class="slider">
                  <strong>Coordenadas: </strong>
                  {{ `${item.LATITUDE || "?"}, ${item.LONGITUDE}` }}
                </div>
              </div>
              <div v-if="item.REQ_PRES">
                <strong>Pressão requerida (bar):</strong> {{ item.REQ_PRES }}
              </div>
              <div v-if="item.CLOSURE_TIME">
                <strong>Fechamento (s):</strong> {{ item.CLOSURE_TIME }}
              </div>
              <div v-if="item.REST_TIME">
                <strong>Descanso (min):</strong> {{ item.REST_TIME }}
              </div>
              <div v-if="item.MIN_FLOW != null || item.MAX_FLOW != null">
                <strong>Vazão (m³/h):</strong> {{ item.MIN_FLOW || "?" }} -
                {{ item.MAX_FLOW || "?" }}
              </div>
              <div v-if="item.NAME_HYDRO">
                <!-- <br /> -->
                <div class="slider">
                  <strong>Hidrômetro: </strong>{{ item.NAME_HYDRO }}
                </div>
              </div>
              <div v-if="item.NAME_SENSOR">
                <div class="slider">
                  <strong>Feedback: </strong> {{ item.NAME_SENSOR }}
                </div>
                <div v-if="sensorFeedbackDetail(item)" class="slider sensor-feedback-condition">
                  {{ sensorFeedbackDetail(item) }}
                </div>
                <div class="slider sensor-feedback-condition">
                  <strong>Intertravamento: </strong>
                  {{
                    item.FEEDBACK_ERR_ENABLED
                      ? `Habilitado (${item.FEEDBACK_ERR_TIME}s)`
                      : "Desabilitado"
                  }}
                </div>
              </div>
              <div v-if="item.NAME_SENSOR_LOCK">
                <div class="slider">
                  <strong>Bloqueio de segurança: </strong> {{ item.NAME_SENSOR_LOCK }}
                </div>
                <div v-if="sensorLockDetail(item)" class="slider sensor-feedback-condition">
                  {{ sensorLockDetail(item) }}
                </div>
              </div>
              <div v-if="item.NAME_SENSOR_POS">
                <div class="slider">
                  <strong>Sensor de posição: </strong> {{ item.NAME_SENSOR_POS }}
                </div>
              </div>
              <div v-if="item.NAME_PUMP">
                <!-- <br /> -->
                <div class="slider">
                  <strong>Bomba:</strong> {{ item.NAME_PUMP }}
                </div>
              </div>
              <div v-if="item.NOTE">
                <strong>Observação:</strong> {{ item.NOTE }}
              </div>
            </div>
            <div class="footer">
              <b-checkbox
                class="checkbox"
                v-show="isAdmin"
                :value="item"
                v-model="selected"
              />
              <div class="show-details-cards">
                <b-link v-if="showDetailsLink(item)" @click="showDetails(item)">
                  Ver medições
                </b-link>
                <b-link
                  v-if="hasSchedulesAssociated(item)"
                  @click="showSchedulesAssociated(item)"
                >
                  Ver agendas
                </b-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL DE REMOÇÃO DE EQUIPAMENTOS -->
    <b-modal
      ref="removeEqp"
      @ok="confirmRemove"
      centered
      ok-title="Deletar"
      ok-variant="danger"
      cancel-title="Cancelar"
      content-class="shadow"
      cancel-variant="outline-secondary"
      title="Atenção!"
      :size="hasAnyEquipmentAssociatedWithShedules ? 'lg' : ''"
      :hide-footer="hasAnyEquipmentAssociatedWithShedules"
    >
      <div class="modal-form">
        <div v-if="hasAnyEquipmentAssociatedWithShedules">
          <b
            >⚠️ Atenção, não será possível remover equipamentos associados a
            agendas.
          </b>
          <div
            v-for="(equipment, index) in equipmentsAssociatedWithSchedules"
            :key="index"
            class="equipments-related-to-agns"
          >
            <span class="equipment-name"
              >Equipamento <b>{{ equipment.NAME }}</b> está associado à
              seguinte(s) agenda(s):</span
            >
            <b-list-group
              class="related-agns"
              v-for="(schedule, index) in equipment.ITEMS"
              :key="index"
            >
              <b-list-group-item>{{ schedule.NAME }}</b-list-group-item>
            </b-list-group>
            <br />
          </div>
        </div>

        <div v-else class="title-modal-info">
          {{
            selected.length == 1
              ? "1 item será apagado"
              : selected.length + " itens serão apagados"
          }}.
          {{ removeMsg }}
        </div>
      </div>
    </b-modal>

    <!-- MODAL DE DETALHES DE SENSORES E MODELOS DE SENSORES -->
    <b-modal
      ref="detailsModal"
      :title="`${
        type.indexOf('sensor') > -1 ? 'Sensor' : 'Atuador'
      } ${detailsName}`"
      centered
      hide-footer
      content-class="shadow"
      :size="type == 'sensors-model' ? 'lg' : ''"
    >
      <b-table
        striped
        small
        borderless
        hover
        responsive
        :items="details"
        :fields="detailsFields()"
      >
        <template slot="MEASURES" slot-scope="row">
          <span v-if="tab1 == 'Sensores'"
            >{{ row.item.TYPE_NAME }} ({{ row.item.UNIT_NAME }})</span
          >
          <span v-if="tab2 == 'M. de Sensores'">{{ row.index + 1 }}</span>
        </template>
        <template slot="FORMULA" slot-scope="row">
          {{ setFormula(row.value) }}
        </template>
        <template slot="TYPE_SNS">
          {{ actuatorSensor.type }}
        </template>
        <template slot="ACT_SNS">
          {{ actuatorSensor.action }}
        </template>
      </b-table>
    </b-modal>

    <!-- MODAL DE DETALHES DE AGENDAS ASSOCIADAS-->
    <b-modal
      ref="schedulesModal"
      :title="detailsName"
      centered
      hide-footer
      content-class="shadow"
      size="lg"
    >
      <b-table
        striped
        small
        borderless
        hover
        responsive
        :items="details"
        :fields="scheduleFromValvesDetailsFields"
      >
      </b-table>
    </b-modal>

    <actuator-form
      v-if="type == 'actuators'"
      :show-form="showForm"
      :form-type="formType"
      :equipment="selectedEquipment"
      :old-name="formType == 'edit' && selected.length ? selected[0].NAME : ''"
      :item-to-edit="selected.length && selected[0]"
      :already-used-names="alreadyNames"
      :actuators-models="actuatorsModels"
      :hydros="hydros"
      :pumps="pumps"
      :sensors="sensors"
      :aux-sensors="auxSensors"
      @submit="submit"
      @close-form="
        showForm = false;
        formType = '';
      "
    />

    <hydro-form
      v-else-if="type == 'hydros'"
      :show-form="showForm"
      :form-type="formType"
      :equipment="selectedEquipment"
      :old-name="formType == 'edit' && selected.length ? selected[0].NAME : ''"
      :item-to-edit="selected.length && selected[0]"
      :already-used-names="alreadyNames"
      :hydro-models="hydroModels"
      @submit="submit"
      @close-form="
        showForm = false;
        formType = '';
      "
    />

    <sensor-form
      v-else-if="type == 'sensors'"
      :show-form="showForm"
      :form-type="formType"
      :equipment="selectedEquipment"
      :old-name="formType == 'edit' && selected.length ? selected[0].NAME : ''"
      :item-to-edit="selected.length && selected[0]"
      :already-used-names="alreadyNames"
      :sensors-models="[...sensorsModels]"
      @submit="submit"
      @close-form="
        showForm = false;
        formType = '';
      "
    />

    <pump-form
      v-else-if="type == 'pumps'"
      :show-form="showForm"
      :form-type="formType"
      :equipment="selectedEquipment"
      :old-name="formType == 'edit' && selected.length ? selected[0].NAME : ''"
      :item-to-edit="selected.length && selected[0]"
      :already-used-names="alreadyNames"
      :actuators-models="actuatorsModels"
      :hydros="hydros"
      :sensors="sensors"
      :aux-sensors="auxSensors"
      @submit="submit"
      @close-form="
        () => {
          showForm = false;
          formType = '';
        }
      "
    />

    <actuator-model-form
      v-else-if="type == 'actuators-model'"
      :show-form="showForm"
      :form-type="formType"
      :equipment="selectedEquipment"
      :old-name="formType == 'edit' && selected.length ? selected[0].NAME : ''"
      :item-to-edit="selected.length && selected[0]"
      :already-used-names="fullList.map((e) => e.NAME)"
      :model-mode="modelMode"
      @submit="submit"
      @close-form="
        () => {
          showForm = false;
          formType = '';
        }
      "
    />
    <!-- :already-used-names="fullList.map((e) => e.NAME)" -->

    <hydro-model-form
      v-else-if="type == 'hydro-model'"
      :show-form="showForm"
      :form-type="formType"
      :equipment="selectedEquipment"
      :old-name="formType == 'edit' && selected.length ? selected[0].NAME : ''"
      :item-to-edit="selected.length && selected[0]"
      :already-used-names="fullList.map((e) => e.NAME)"
      @submit="submit"
      @close-form="
        showForm = false;
        formType = '';
      "
    />

    <!-- :already-used-names="fullList.map((e) => e.NAME)" -->
    <sensor-model-form
      v-else-if="type == 'sensors-model'"
      :show-form="showForm"
      :form-type="formType"
      :equipment="selectedEquipment"
      :old-name="formType == 'edit' && selected.length ? selected[0].NAME : ''"
      :item-to-edit="selected.length && selected[0]"
      :already-used-names="fullList.map((e) => e.NAME)"
      :sensors-interfaces="sensorsInterfaces"
      :sensors-types="sensorsTypes"
      :sensors-units="sensorsUnits"
      @submit="submit"
      @close-form="
        showForm = false;
        formType = '';
      "
    />
  </div>
</template>

<script>
import {
  dirs,
  mtd,
  listEquipments,
  hydros,
  valves,
  pumps,
  // actuators,
  sensors,
  modelsHydro,
  modelsSensor,
  modelsValve,
  // modelsActuator
} from "@/api";
import { cookies } from "@/pages/components/cookies";
import PageTitle from "@/pages/temps/components/PageTitle.vue";
export default {
  name: "equipments",
  components: {
    PageTitle,
  },
  props: {
    local: [String],
    mobile: Boolean,
  },
  created() {
    this.$emit("title-change", "Equipamentos");
    this.isAdmin = Number(cookies.get("PERMISSION")) == 1;
    // if (!this.type) {
    //   this.type = "actuators";
    // }
    // this.getEquipmentsNames(this.type)
    //   .then((eqp) => {
    //     this.alreadyNames = eqp;
    //     return this.renderAllDirs();
    //   })
    this.renderAllDirs()
      .then(
        (data) => {
          this.listDIR = data;
        },
        (err) => {
          console.log(err);
          this.listDIR = [];
        },
      )
      .then((_) => {
        this.dirAddrByName = this.buildDirAddrMap();
        this.isActive();
      });
  },
  data() {
    return {
      title: "",
      showForm: false,
      formDepsLoadedFor: null,
      dirAddrByName: null,
      type: "actuators",
      loading: true,
      errorMsg: "Ocorreu um erro. Recarregue a página e tente novamente.",
      ismob: false,
      emptyIcon: require("../../../assets/icons/Empty.svg"),
      searchIcon: require("../../../assets/icons/search.svg"),
      tab1: "",
      tab2: "",
      list: [],
      fullList: [],
      isSearching: false,
      filter: "",
      selected: [],
      allSelected: false,
      formType: null,
      alreadyNames: [],
      modelMode: [
        "Nível",
        "Pulso (ms)",
        "Pulso cíclico (s)",
        "Modbus",
        "Nível temporizado (min)",
        "Sequencial",
        "Contador",
        "Pivô Central",
      ],
      detailsName: "",
      details: [],
      auxSensors: [],
      sensorDetailsFields: [
        {
          key: "MEASURES",
          label: "Medição",
        },
        {
          key: "MIN_VALUE",
          label: "Mínimo",
        },
        {
          key: "MAX_VALUE",
          label: "Máximo",
        },
      ],
      sensorModelDetailsFields: [
        {
          key: "MEASURES",
          label: "Medição",
        },
        {
          key: "TYPE_NAME",
          label: "Tipo",
        },
        {
          key: "UNIT_NAME",
          label: "Unidade",
        },
        {
          key: "FORMULA",
          label: "Fórmula",
        },
      ],
      valveDetailsFields: [
        {
          key: "TYPE_SNS",
          label: "Medida do Sensor",
        },
        {
          key: "ACT_SNS",
          label: "Ação do Sensor",
        },
      ],
      scheduleFromValvesDetailsFields: [
        {
          key: "ID",
          label: "Id da agenda",
        },
        {
          key: "NAME",
          label: "Agenda",
        },
      ],

      actuatorSensor: {
        type: "",
        action: "",
      },
      // actuators: [],
      // actuatorType: ['Bomba','Válvula'],
      hydros: [],
      sensors: [],
      pumps: [],
      actuatorsModels: [],
      hydroModels: [],
      sensorsModels: [],
      sensorsUnits: [],
      sensorsInterfaces: [],
      sensorsTypes: [],
      equipments: [
        {
          type: "actuators",
          name: "ATUADORES",
        },
        {
          type: "hydros",
          name: "HIDRÔMETROS",
        },
        {
          type: "sensors",
          name: "SENSORES",
        },
        {
          type: "pumps",
          name: "BOMBAS",
        },
      ],
      models: [
        {
          type: "actuators-model",
          name: "MODELOS DE ATUADORES",
        },
        {
          type: "hydro-model",
          name: "MODELOS DE HIDRÔMETROS",
        },
        {
          type: "sensors-model",
          name: "MODELOS DE SENSORES",
        },
      ],
      showErrorNotFound: false,
      showErrorNotSearch: false,
      listDIR: [],
    };
  },
  watch: {
    $route() {
      this.selected = [];
      this.allSelected = false;
      this.type = this.$route.params.type;
      this.isActive();
    },
    type() {
      this.loading = true;
      this.isActive();
    },
  },
  computed: {
    equipmentsAssociatedWithSchedules() {
      return this.selected
        .filter((selectedItem) => {
          return (
            Reflect.has(selectedItem, "SCHEDULES") &&
            selectedItem.SCHEDULES.length > 0
          );
        })
        .map((selectedItem) => ({
          NAME: selectedItem.NAME,
          ITEMS: selectedItem.SCHEDULES.map((schedule) => ({
            ID: schedule.ID,
            NAME: schedule.NAME,
          })),
        }));
    },
    hasAnyEquipmentAssociatedWithShedules() {
      return this.equipmentsAssociatedWithSchedules.length > 0;
    },
    computedClass() {
      this.ismob = this.mobile;
      let className = "row align-items-center header";
      if (this.mobile) {
        className = "row align-items-center header-mobile";
        return className;
      }
      return className;
    },
    validFilter() {
      return !!this.filter.split(" ").join("");
    },
    //título do modal de adição
    selectedEquipment() {
      if (this.type == "actuators") return "atuador";
      else if (this.type == "hydros") return "hidrômetro";
      else if (this.type == "sensors") return "sensor";
      else if (this.type == "pumps") return "bomba";
      else if (this.type == "actuators-model") return "modelo de atuador";
      else if (this.type == "hydro-model") return "modelo de hidrômetro";
      else if (this.type == "sensors-model") return "modelo de sensor";
    },
    removeMsg() {
      let msg = "";
      if (this.type == "hydros")
        return "Caso haja associações deste hidrômetro com atuadores e setores essas associações também serão deletadas.";
      else if (this.type == "sensors")
        return "Caso haja associações deste sensor com setores, estas associações também serão deletadas.";
      else return "";
    },
  },
  methods: {
    sensorFeedbackDetail(item) {
      if (item.POS_SENSOR == null || item.ACTION_SENSOR == null || item.VALUE_SENSOR == null) return null;
      const aux = this.auxSensors.find(e => e.ID == item.FK_SENSOR && e.POS == item.POS_SENSOR);
      if (!aux) return null;
      const op = item.ACTION_SENSOR === 0 ? '>' : '<';
      return `${aux.NAME_TYPE} (${aux.NAME_UNIT}) ${op} ${item.VALUE_SENSOR}`;
    },
    sensorLockDetail(item) {
      if (item.POS_SENSOR_LOCK == null) return null;
      if (item.MIN_VALUE_SENSOR_LOCK == null && item.MAX_VALUE_SENSOR_LOCK == null) return null;
      const aux = this.auxSensors.find(e => e.ID == item.FK_SENSOR_LOCK && e.POS == item.POS_SENSOR_LOCK);
      if (!aux) return null;
      const min = item.MIN_VALUE_SENSOR_LOCK ?? "?";
      const max = item.MAX_VALUE_SENSOR_LOCK ?? "?";
      return `${aux.NAME_TYPE} (${aux.NAME_UNIT}) entre ${min} e ${max}`;
    },
    //apenas para atuadores
    getActuatorSensorType(item) {
      let id = item.FK_SENSOR;
      let pos = item.POS_SENSOR;
      if (id && this.auxSensors.length) {
        let sensor = this.auxSensors.filter(
          (e) => e.ID == id && e.POS == pos,
        )[0];
        if (sensor) return sensor.NAME_TYPE;
      }
      return "-";
    },
    getActuatorSensorAction(action) {
      if (action !== null) return ["Ação inversa", "Ação direta"][action];
      else return "-";
    },
    //apenas para atuadores, sensores e modelos de sensores
    showDetailsLink(item) {
      return (
        ["sensors", "sensors-model"].includes(this.type) &&
        (item.RANGE || item.MEASURES)
      );
    },
    hasSchedulesAssociated(item) {
      if (["actuators"].includes(this.type) && Reflect.has(item, "SCHEDULES")) {
        return item.SCHEDULES.length > 0;
      }
    },
    showSchedulesAssociated(item) {
      this.details = item.SCHEDULES;
      this.detailsName = `Atuador ${item.NAME}`;
      this.$refs.schedulesModal.show();
    },
    showDetails(item) {
      let preventOpen;
      if (this.type == "sensors") this.details = item.RANGE;
      else if (this.type == "sensors-model") this.details = item.MEASURES;
      else if (this.type == "actuators") {
        if (item.FK_SENSOR) {
          this.details = [item];
          let type = this.getActuatorSensorType(item);
          let action = this.getActuatorSensorAction(item.ACTION_SENSOR);
          this.actuatorSensor = {
            type,
            action,
          };
        } else {
          alert(`Não há sensor conectado ao atuador ${item.NAME}`, "i");
          preventOpen = true;
        }
      }
      this.detailsName = item.NAME;
      if (!preventOpen) this.$refs.detailsModal.show();
    },
    detailsFields() {
      if (this.type == "sensors") return this.sensorDetailsFields;
      else if (this.type == "sensors-model")
        return this.sensorModelDetailsFields;
      else if (this.type == "actuators") return this.valveDetailsFields;
    },
    //apenas para sensores e modelos de sensores
    setFormula(x) {
      if (x) {
        let items = x.split(",");
        items.reverse();
        let grau = ["", "x", "x²", "x³"];
        let result = "";
        for (let i = 0; i < items.length; i++) {
          if (items[i] != "0" && items[i] != "+0" && items[i] != "-0")
            result = result + items[i] + grau[i] + "|";
        }
        result = result.split("|");
        result.reverse();
        return result.reduce((total, i) => total + i);
      } else return "";
    },
    // Pools dos dropdowns do formulário: buscados sob demanda ao abrir Adicionar/Editar
    // (em paralelo), não na abertura da tela. Cache por tipo, invalidado após criar/editar/remover.
    async loadFormDependencies() {
      if (this.formDepsLoadedFor === this.type) return;

      if (this.type == "actuators" || this.type == "pumps") {
        const [pumps, models, hydros, sensorsRet, names] = await Promise.all([
          listEquipments.pumps().catch(() => []),
          listEquipments.modelsValve().catch(() => []),
          listEquipments.hydros().catch(() => []),
          listEquipments.sensors().catch(() => ({ sensors: [], aux: [] })),
          this.getEquipmentsNames(this.type).catch(() => []),
        ]);
        this.pumps = pumps;
        this.actuatorsModels = models;
        this.hydros = hydros;
        this.sensors = sensorsRet.sensors;
        this.auxSensors = sensorsRet.aux;
        this.alreadyNames = names;
      } else if (this.type == "hydros") {
        const [models, names] = await Promise.all([
          listEquipments.modelsHydro().catch(() => []),
          this.getEquipmentsNames(this.type).catch(() => []),
        ]);
        this.hydroModels = models;
        this.alreadyNames = names;
      } else if (this.type == "sensors") {
        const [models, names] = await Promise.all([
          listEquipments.modelsSensor().catch(() => []),
          this.getEquipmentsNames(this.type).catch(() => []),
        ]);
        this.sensorsModels = models;
        this.alreadyNames = names;
      } else if (this.type == "sensors-model") {
        const [units, interfaces, types] = await Promise.all([
          modelsSensor.units().catch(() => []),
          modelsSensor.interfaces().catch(() => []),
          modelsSensor.types().catch(() => []),
        ]);
        this.sensorsUnits = units;
        this.sensorsInterfaces = interfaces;
        this.sensorsTypes = types;
      }
      // actuators-model e hydro-model usam fullList.map(NAME): sem pool a buscar.

      this.formDepsLoadedFor = this.type;
    },
    //checkboxes
    toggleAll() {
      this.allSelected = !this.allSelected;
      if (this.selected.length < this.list.length)
        this.selected = this.list.slice();
      else if (this.selected.length == this.list.length) this.selected = [];
    },
    //auxiliar de exclusão de sensores
    organizeSensorsByType() {
      let sensors = {
        i2c: "",
        sdi12: "",
        ana: "",
        elements: [],
      };
      sensors.elements = this.selected;
      for (let i = 0; i < sensors.elements.length; i++) {
        if (
          sensors.elements[i].TYPE_SENSOR == "GS3" ||
          sensors.elements[i].TYPE_SENSOR == "SDI12"
        )
          sensors.gs3 = sensors.gs3 + sensorselements[i].ID + ",";
        else if (
          sensors.elements[i].TYPE_SENSOR == "SHT31" ||
          sensors.elements[i].TYPE_SENSOR == "I2C"
        )
          sensors.sht31 = sensors.sht31 + sensors.elements[i].ID + ",";
        else sensors.ana = sensors.ana + sensors.elements[i].ID + ",";
      }
      sensors.i2c = sensors.i2c.substring(0, sensors.i2c.length - 1);
      sensors.sdi12 = sensors.sdi12.substring(0, sensors.sdi12.length - 1);
      sensors.ana = sensors.ana.substring(0, sensors.ana.length - 1);
      return sensors;
    },
    //excluir itens da lista de selecionados
    makeAlert(ret) {
      if (ret) alert(ret.log, ret.alert);
      else alert(this.errorMsg);
    },
    removeDialog() {
      this.$refs.removeEqp.show();
    },
    async loadEquipment(type, callback) {
      try {
        let onlyNames = [];
        const eqps = await callback();
        if (type === "SENSORES") {
          onlyNames = eqps.sensors.map((eqp) => eqp.NAME);
          return onlyNames;
        }
        onlyNames = eqps.map((eqp) => eqp.NAME);
        return onlyNames;
      } catch (error) {
        console.error(error);
      }
      return [];
    },
    async getEquipmentsNames(type) {
      let equipments = [];
      if (type == "actuators" || type == "pumps") {
        const valves = await this.loadEquipment(
          "ATUADORES",
          listEquipments.valves,
        );
        equipments = [...equipments, ...valves];
        const pumps = await this.loadEquipment("BOMBAS", listEquipments.pumps);
        equipments = [...equipments, ...pumps];
        return new Promise((resolve) => {
          resolve(equipments);
        });
      } else if (type == "sensors" || type == "hydros") {
        const hydros = await this.loadEquipment(
          "HIDRÔMETROS",
          listEquipments.hydros,
        );
        equipments = [...equipments, ...hydros];
        const sensors = await this.loadEquipment(
          "SENSORES",
          listEquipments.sensors,
        );
        equipments = [...equipments, ...sensors];
        return new Promise((resolve) => {
          resolve(equipments);
        });
      }
    },
    confirmRemove() {
      this.formDepsLoadedFor = null;
      if (this.type == "actuators") {
        // actuators.del(this.selected).then(ret => {
        valves
          .del(this.selected)
          .then((ret) => {
            this.makeAlert(ret);
            if (ret.alert == "s") {
              this.getEquipmentsNames(this.type).then((eqp) => {
                this.alreadyNames = eqp;
                this.loadActuators();
                this.selected = [];
              });
            }
          })
          .catch((err) => {
            this.makeAlert();
            this.selected = [];
          });
      } else if (this.type == "hydros") {
        hydros
          .del(this.selected)
          .then((ret) => {
            this.makeAlert(ret);
            if (ret.alert == "s") {
              this.getEquipmentsNames(this.type).then((eqp) => {
                this.alreadyNames = eqp;
                this.loadHydros();
                this.selected = [];
              });
            }
          })
          .catch((err) => {
            this.makeAlert();
            this.selected = [];
          });
      } else if (this.type == "sensors") {
        sensors
          .del(this.organizeSensorsByType())
          .then((ret) => {
            this.makeAlert(ret);
            if (ret.alert == "s") {
              this.getEquipmentsNames(this.type).then((eqp) => {
                this.alreadyNames = eqp;
                this.loadSensors();
                this.selected = [];
              });
            }
          })
          .catch((err) => {
            this.makeAlert();
            this.selected = [];
          });
      } else if (this.type == "pumps") {
        pumps
          .del(this.selected)
          .then((ret) => {
            this.makeAlert(ret);
            if (ret.alert == "s") {
              this.getEquipmentsNames(this.type).then((eqp) => {
                this.alreadyNames = eqp;
                this.loadPumps();
                this.selected = [];
              });
            }
          })
          .catch((err) => {
            this.makeAlert();
            this.selected = [];
          });
      } else if (this.type == "actuators-model") {
        // modelsActuator.del(this.selected).then(ret => {
        modelsValve
          .del(this.selected)
          .then((ret) => {
            this.makeAlert(ret);
            if (ret.alert == "s") {
              this.loadModelsActuator();
              this.selected = [];
            }
          })
          .catch((err) => {
            this.makeAlert();
            this.selected = [];
          });
      } else if (this.type == "hydro-model") {
        modelsHydro
          .del(this.selected)
          .then((ret) => {
            this.makeAlert(ret);
            if (ret.alert == "s") {
              this.loadModelsHydro();
              this.selected = [];
            }
          })
          .catch((err) => {
            this.makeAlert();
            this.selected = [];
          });
      } else if (this.type == "sensors-model") {
        modelsSensor
          .del(this.selected)
          .then((ret) => {
            this.makeAlert(ret);
            if (ret.alert == "s") {
              this.loadModelsSensor();
              this.selected = [];
            }
          })
          .catch((err) => {
            this.makeAlert();
            this.selected = [];
          });
      }
      this.$refs.removeEqp.hide();
    },
    //pré-definição dos campos na área de edição
    async edit() {
      await this.openForm("edit");
    },
    submit(data) {
      this.formDepsLoadedFor = null;
      if (this.type == "actuators") {
        valves[this.formType](data)
          .then((ret) => {
            this.makeAlert(ret);
            if (ret.alert == "s") {
              this.getEquipmentsNames(this.type).then((eqp) => {
                this.alreadyNames = eqp;
                this.loadActuators();
              });
              // this.resetForm();
            }
          })
          .catch((err) => this.makeAlert());
      } else if (this.type == "hydros") {
        hydros[this.formType](data)
          .then((ret) => {
            this.makeAlert(ret);
            if (ret.alert == "s") {
              this.getEquipmentsNames(this.type).then((eqp) => {
                this.alreadyNames = eqp;
                this.loadHydros();
              });
              // this.resetForm();
            }
          })
          .catch((err) => this.makeAlert());
      } else if (this.type == "sensors") {
        sensors[this.formType](data)
          .then((ret) => {
            this.makeAlert(ret);
            if (ret.alert == "s") {
              this.getEquipmentsNames(this.type).then((eqp) => {
                this.alreadyNames = eqp;
                this.loadSensors();
              });
              // this.resetForm();
            }
          })
          .catch((err) => this.makeAlert());
      } else if (this.type == "pumps") {
        pumps[this.formType](data)
          .then((ret) => {
            this.makeAlert(ret);
            if (ret.alert == "s") {
              this.getEquipmentsNames(this.type).then((eqp) => {
                this.alreadyNames = eqp;
                this.loadPumps();
              });
              // this.resetForm();
            }
          })
          .catch((err) => this.makeAlert());
      } else if (this.type == "actuators-model") {
        modelsValve[this.formType](data)
          .then((ret) => {
            this.makeAlert(ret);
            if (ret.alert == "s") {
              this.loadModelsActuator();
            }
          })
          .catch((err) => this.makeAlert());
      } else if (this.type == "hydro-model") {
        modelsHydro[this.formType](data)
          .then((ret) => {
            this.makeAlert(ret);
            if (ret.alert == "s") {
              this.loadModelsHydro();
            }
          })
          .catch((err) => this.makeAlert());
      } else if (this.type == "sensors-model") {
        modelsSensor[this.formType](data)
          .then((ret) => {
            this.makeAlert(ret);
            if (ret.alert == "s") {
              this.loadModelsSensor();
            }
          })
          .catch((err) => this.makeAlert());
      }
    },
    //adicionar um novo equipamento ao sistema
    async add() {
      await this.openForm("add");
    },
    // Opção (a): aguarda os pools antes de exibir o formulário, garantindo dropdowns preenchidos.
    openForm(formType) {
      this.loading = true;
      return this.loadFormDependencies()
        .catch((e) =>
          console.error("Falha ao carregar dados do formulário.", e),
        )
        .then(() => {
          this.formType = formType;
          this.showForm = true;
          this.loading = false;
        });
    },
    //referente à sinalização na aba de Equipamentos
    //também faz a troca dos itens para disposição na tela
    isActive() {
      this.list = [];
      this.isSearching = false;
      this.filter = "";
      if (this.type == "actuators") {
        this.tab1 = "Atuadores";
        this.title = "Atuadores";
        this.tab2 = "";
        this.loadActuators();
      } else if (this.type == "hydros") {
        this.tab1 = "Hidrômetros";
        this.title = "Hidrômetros";
        this.tab2 = "";
        this.loadHydros();
      } else if (this.type == "sensors") {
        this.tab1 = "Sensores";
        this.title = "Sensores";
        this.tab2 = "";
        this.loadSensors();
      } else if (this.type == "pumps") {
        this.tab1 = "Bombas";
        this.title = "Bombas";
        this.tab2 = "";
        this.loadPumps();
      } else if (this.type == "actuators-model") {
        this.loadModelsActuator();
        this.tab1 = "";
        this.tab2 = "M. Atuadores";
        this.title = "M.Atuador";
      } else if (this.type == "hydro-model") {
        this.loadModelsHydro();
        this.tab1 = "";
        this.tab2 = "M. Hidrômetros";
        this.title = "M.Hidrômetro";
      } else if (this.type == "sensors-model") {
        this.loadModelsSensor();
        this.tab1 = "";
        this.tab2 = "M. Sensores";
        this.title = "M.Sensor";
      }
    },
    // Mapa nome-do-equipamento -> ADDR do DIR, construído UMA vez a partir de listDIR.
    // Substitui o antigo casamento O(equip × dirs × colunas) (que recriava Object.values(dir)
    // a cada iteração) por lookup O(1). Mantém o comportamento: último DIR com o nome prevalece.
    buildDirAddrMap() {
      const map = new Map();
      for (const dir of this.listDIR) {
        for (const value of Object.values(dir)) {
          if (typeof value === "string") map.set(value, dir.ADDR);
        }
      }
      return map;
    },
    annotateDirAddr(items) {
      const map = this.dirAddrByName || (this.dirAddrByName = this.buildDirAddrMap());
      for (const item of items) {
        const addr = map.get(item.NAME);
        if (addr !== undefined) item.ID_DIR = addr;
      }
      return items;
    },
    renderAllDirs() {
      return new Promise((resolve, reject) => {
        let dirs_list = [];
        dirs
          .list()
          .then(
            (dirs) => {
              if (dirs.length) {
                dirs_list = [...dirs_list, ...dirs];
              }
              return mtd.list();
            },
            (err) => {
              console.error("[DIRS] - Falha ao carregar dirs -> ", err);
              return mtd.list();
            },
          )
          .then(
            (mtd) => {
              if (mtd.length) {
                dirs_list = [...dirs_list, ...mtd];
              }
              resolve(dirs_list);
            },
            (err) => {
              console.error("[MTD] - Falha ao carregar mtds -> ", err);
              resolve(dirs_list);
            },
          );
      });
    },
    loadActuators() {
      this.selected = [];
      this.loading = true;
      this.showErrorNotFound = false;
      listEquipments
        .valves()
        .then((ret) => {
          let valves = this.annotateDirAddr(ret);
          this.list = valves;
          this.fullList = this.list.map((e) => e);
        })
        .catch((err) => {
          this.list = [];
          this.fullList = [];
          console.log(err);
          alert("Ocorreu um erro ao carregar equipamentos.");
        })
        .then((_) => (this.loading = false))
        .then((_) => {
          if (
            !this.list.length &&
            this.showErrorNotSearch === false &&
            !this.loading
          ) {
            this.showErrorNotFound = true;
          } else {
            this.showErrorNotFound = false;
          }
        });
    },
    loadHydros() {
      this.selected = [];
      this.loading = true;
      this.showErrorNotFound = false;
      listEquipments
        .hydros()
        .then((ret) => {
          let hydros = this.annotateDirAddr(
            ret.map((hydro) => {
              hydro.NOTE = hydro.NOTE
                ? hydro.NOTE.replace(/\\"/g, '"')
                : hydro.NOTE;
              return hydro;
            })
          );
          this.list = hydros;
          this.fullList = this.list.map((e) => e);
        })
        .catch((err) => {
          this.list = [];
          this.fullList = [];
          console.log(err);
          alert("Ocorreu um erro ao carregar equipamentos.");
        })
        .then((_) => (this.loading = false))
        .then((_) => {
          if (
            !this.list.length &&
            this.showErrorNotSearch === false &&
            !this.loading
          ) {
            this.showErrorNotFound = true;
          } else {
            this.showErrorNotFound = false;
          }
        });
    },
    loadSensors() {
      this.selected = [];
      this.loading = true;
      this.showErrorNotFound = false;
      listEquipments
        .sensors()
        .then((ret) => {
          this.auxSensors = ret.aux;
          let formatedSensors = this.annotateDirAddr(
            ret.sensors.map((e) => {
              e.NOTE = e.NOTE ? e.NOTE.replace(/\\"/g, '"') : e.NOTE;
              return e;
            })
          );
          this.list = formatedSensors;
          this.fullList = this.list.map((e) => e);
        })
        .catch((err) => {
          this.list = [];
          this.fullList = [];
          console.log(err);
          alert("Ocorreu um erro ao carregar equipamentos.");
        })
        .then((_) => (this.loading = false))
        .then((_) => {
          if (
            !this.list.length &&
            this.showErrorNotSearch === false &&
            !this.loading
          ) {
            this.showErrorNotFound = true;
          } else {
            this.showErrorNotFound = false;
          }
        });
    },
    loadPumps() {
      this.selected = [];
      this.loading = true;
      this.showErrorNotFound = false;
      listEquipments
        .pumps()
        .then((ret) => {
          let pumps = this.annotateDirAddr(ret);
          this.list = pumps;
          this.fullList = this.list.map((e) => e);
        })
        .catch((err) => {
          this.list = [];
          this.fullList = [];
          console.log(err);
          alert("Ocorreu um erro ao carregar equipamentos.");
        })
        .then((_) => (this.loading = false))
        .then((_) => {
          if (
            !this.list.length &&
            this.showErrorNotSearch === false &&
            !this.loading
          ) {
            this.showErrorNotFound = true;
          } else {
            this.showErrorNotFound = false;
          }
        });
    },
    loadModelsHydro() {
      this.selected = [];
      this.loading = true;
      this.showErrorNotFound = false;
      listEquipments
        .modelsHydro()
        .then((ret) => {
          this.list = ret;
          this.fullList = this.list.map((e) => e);
        })
        .catch((err) => {
          this.list = [];
          this.fullList = [];
          console.log(err);
          alert("Ocorreu um erro ao carregar modelos de equipamento.");
        })
        .then((_) => (this.loading = false))
        .then((_) => {
          if (
            !this.list.length &&
            this.showErrorNotSearch === false &&
            !this.loading
          ) {
            this.showErrorNotFound = true;
          } else {
            this.showErrorNotFound = false;
          }
        });
    },
    loadModelsActuator() {
      this.selected = [];
      this.loading = true;
      this.showErrorNotFound = false;
      // listEquipments.modelsActuator().then(ret =>
      listEquipments
        .modelsValve()
        .then((ret) => {
          this.list = ret;
          this.fullList = this.list.map((e) => e);
        })
        .catch((err) => {
          this.list = [];
          this.fullList = [];
          console.log(err);
          alert("Ocorreu um erro ao carregar modelos de equipamento.");
        })
        .then((_) => (this.loading = false))
        .then((_) => {
          if (
            !this.list.length &&
            this.showErrorNotSearch === false &&
            !this.loading
          ) {
            this.showErrorNotFound = true;
          } else {
            this.showErrorNotFound = false;
          }
        });
    },
    loadModelsSensor() {
      this.selected = [];
      this.loading = true;
      this.showErrorNotFound = false;
      listEquipments
        .modelsSensor()
        .then((ret) => {
          this.list = ret;
          this.fullList = this.list.map((e) => e);
        })
        .catch((err) => {
          this.list = [];
          this.fullList = [];
          console.log(err);
          alert("Ocorreu um erro ao carregar modelos de equipamento.");
        })
        .then((_) => (this.loading = false))
        .then((_) => {
          if (
            !this.list.length &&
            this.showErrorNotSearch === false &&
            !this.loading
          ) {
            this.showErrorNotFound = true;
          } else {
            this.showErrorNotFound = false;
          }
        });
    },
    searchBy(name) {
      this.selected = [];
      this.isSearching = !!name.split(" ").join("");
      this.filter = name.toUpperCase();
      if (this.isSearching && this.validFilter && this.fullList.length) {
        this.list = this.fullList.filter((item) => {
          if (item.NAME && item.NAME.indexOf(this.filter) > -1) {
            return true;
          } else if (
            item.NAME_MODEL &&
            item.NAME_MODEL.indexOf(this.filter) > -1
          ) {
            return true;
          } else if (
            item.NAME_GROUP &&
            item.NAME_GROUP.indexOf(this.filter) > -1
          ) {
            return true;
          } else if (item.MAKER && item.MAKER.indexOf(this.filter) > -1) {
            return true;
          }
        });
        if (this.list.length) {
          this.showErrorNotSearch = false;
        } else {
          this.showErrorNotSearch = true;
        }
      } else {
        this.list = this.fullList.map((e) => e);
      }
    },
    clearSearch() {
      this.selected = [];
      this.isSearching = false;
      this.showErrorNotSearch = false;
      this.list = this.fullList.map((e) => e);
      this.$refs.INP.clearText();
    },
  },
};
</script>

<style scoped>
p {
  margin-bottom: 5px;
}
.card-name {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card-name .material-design-icon {
  font-size: 1.3em;
  color: var(--green-3v3);
  align-self: flex-start;
}
.eqp-card {
  padding-bottom: 55px !important;
  min-height: 230px;
}
.header-maker,
.header-model {
  color: #e07f52;
  font-size: 0.88em;
}
.container-card-header {
  width: 88%;
}
.header-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 30px);
  /* max-width: 177px; */
}
h5 {
  word-break: break-all;
  color: var(--text-gray-primary);
  font-weight: 600;
}
.card-details {
  padding-top: 3px;
  font-size: 0.86em;
  color: var(--text-gray-primary);
  text-overflow: ellipsis;
  line-height: 1.4em;
}
.card-details strong {
  color: var(--text-gray-primary);
}
.sensor-feedback-condition {
  color: var(--green-3v3);
  font-size: 0.82em;
  padding-left: 4px;
}
.scrollable {
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 2px;
}
.header {
  flex-basis: 34px;
}
.show-details-cards a {
  padding: 3px 6px;
  border-radius: 5px;
  min-height: 1.5em;
  border: 1px solid #bebebe;
  font-weight: 500;
  font-size: 0.7em;
  color: #a1a1a1;
  transition: all 0.4s ease;
}
.show-details-cards a:hover {
  background: #f5f5f5;
}
.register-page-warning {
  overflow-y: auto;
  overflow-x: hidden;
  height: 95.8%;
}
.footer {
  height: 35px;
  padding: 0 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header-mobile {
  min-height: 29px;
}
@media screen and (max-width: 991px) {
  .register-main {
    margin-bottom: 70px;
  }
}
@media screen and (max-width: 767px) {
  .header-card {
    min-height: 40px;
    overflow: hidden;
    text-overflow: ellipsis;
    border-bottom: 1px solid #ececec;
  }
  .header {
    min-height: 90px;
  }
}
@media screen and (max-width: 676px) {
  .eqp-card {
    padding-bottom: 45px !important;
  }
}
</style>
